import { render, staticRenderFns } from "./CustomerMail.vue?vue&type=template&id=8eee92b0"
import script from "./CustomerMail.vue?vue&type=script&lang=js"
export * from "./CustomerMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports